import { useCallback, useRef } from "react";

export const useClipboard = () => {
  const ref = useRef(null);
  /**
     * 将文本复制到剪贴板
     * @param {string | number | null} text - 要复制的文本
     * @returns {Promise<string | number>} - 返回一个Promise，成功时返回复制的文本，失败时返回错误信息
     */
  const copyToClipboard = useCallback((text?: string | number | null) => new Promise<string | number>((res, rej) => {
    try {
      let copyText = text;

      if (!copyText) {
        copyText = (ref.current as unknown as HTMLInputElement)?.value;
      }

      if (!copyText) {
        const error = 'The copied content cannot be empty';
        rej(error);
        return;
      }

      if (typeof copyText !== 'string' && typeof copyText !== 'number') {
        const error = 'The copied content must be a string or a number';
        rej(error);
        return;
      }

      navigator.clipboard

        .writeText(copyText.toString())
        .then(() => {
          res(copyText as string | number);
        })
        .catch((err) => {
          rej(err);
        });
    } catch (error) {
      rej(error);
    }
  }), []);

  /**
     * 获取剪贴板中的文本
     * @returns {Promise<string>} - 返回一个Promise，成功时返回剪贴板中的文本，失败时返回错误信息
     */
  const getClipboard = useCallback(() => navigator.clipboard.readText(), []);

  return [ref, { copyToClipboard, getClipboard }] as const;
};